<template lang='pug'>
  bf-flex.block.centered.ha-social.component
    img.facebook.actionable(
      src='/ui/facebook.png'
      @click='social("facebook")'
    )
    img.google.actionable(
      src='/ui/google-plus.png'
      @click='social("google")'
    )
    router-link(:to='{ name: "sign-up-phone", params: {id: id} }')
      img.phone(src='/ui/phone.png')
</template>

<script>
  import { auth, firebase, db } from '@/main'
  import { Authenticable } from '@/mixins/authenticable'

  export default {
    name: 'component.bf-social-auth',

    mixins: [ Authenticable ],

    props: ['id'],

    methods: {
      social( provider ) {
        switch (provider) {
          case 'google':
            provider = new firebase.auth.GoogleAuthProvider()
            break
          case 'facebook':
            provider = new firebase.auth.FacebookAuthProvider()
            break
          case 'twitter':
            provider = new firebase.auth.TwitterAuthProvider()
            break
        }
        auth.signInWithPopup( provider ).then( async doc => {
          let acc = await db.collection( 'accounts' ).doc( doc.user.uid ).get()
          if ( acc.exists ) {
            if ( acc.data().merchant ) this.$emit( 'sign-in', acc )
          }
          else this.$emit( 'sign-up', doc )
        }).catch( e => this.message = e.message )
      }
    }
  }

</script>

<style scoped lang='stylus'>
  .component
    img
      width 36px
      margin 0 12px
</style>
